jQuery(function ($) {
  function goToSlideForImage(imageId) {
    var $slider = $('.vertical-slider-for');
    if (!$slider.length || !$slider.hasClass('slick-initialized') || !imageId) {
      return;
    }
    var $targetWrap = $slider.find('[data-image-id="' + imageId + '"]').closest('.slick-slide');
    if ($targetWrap.length) {
      var slideIndex = $targetWrap.data('slick-index');
      $slider.slick('slickGoTo', slideIndex);
    }
  }

  function findMatchingVariant(product, $form) {
    var selected = [];
    $form.find('.swatch[data-option-index]').each(function () {
      var idx = parseInt($(this).attr('data-option-index'), 10);
      var val = $(this).find(':radio:checked').val();
      selected[idx] = val;
    });
    if (!selected.length) {
      return null;
    }
    for (var i = 0; i < product.variants.length; i++) {
      var v = product.variants[i];
      var matches = true;
      for (var j = 0; j < selected.length; j++) {
        if (selected[j] !== undefined && v.options[j] !== selected[j]) {
          matches = false;
          break;
        }
      }
      if (matches) {
        return v;
      }
    }
    return null;
  }

  $(document).on('change', '.swatch :radio', function () {
    var $form = $(this).closest('form');
    var sectionId = $(this).closest('[data-section-id]').attr('data-section-id');
    var $json = $('#ProductJson-' + sectionId);
    if (!$json.length) {
      return;
    }
    var product;
    try {
      product = JSON.parse($json.html());
    } catch (e) {
      return;
    }
    var variant = findMatchingVariant(product, $form);
    if (variant && variant.featured_image) {
      goToSlideForImage(variant.featured_image.id);
    }
  });

  window.hardwareSwatchGoToSlideForImage = goToSlideForImage;
});
